import styled from 'styled-components';

export const Title=styled.h1`
    margin: 20px 20px;
    font-size: 60px;
    text-align: center;
    font-weight: 700;
    background: linear-gradient(104.74deg, #050A27 0%,#4A548C 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    /*mobile versions */

    @media (max-width: 720px) {
    font-size: 40px;
    }
  `